/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multi_Language_Support_InfoInputs */

const en_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-Language support is offered for content with a mix of English, Spanish, French, German, Hindi, Russian, Portuguese, Japanese, Italian, and Dutch.`)
};

const fr_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prise en charge multilingue est offerte pour le contenu mélangeant l’anglais, l’espagnol, le français, l’allemand, l’hindi, le russe, le portugais, le japonais, l’italien et le néerlandais.`)
};

const de_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wird Unterstützung für mehrere Sprachen angeboten, darunter Englisch, Spanisch, Französisch, Deutsch, Hindi, Russisch, Portugiesisch, Japanisch, Italienisch und Niederländisch.`)
};

const it_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il supporto multilingue è offerto per i contenuti con un mix di inglese, spagnolo, francese, tedesco, hindi, russo, portoghese, giapponese, italiano e olandese.`)
};

const ru_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для контента, представленного на английском, испанском, французском, немецком, хинди, русском, португальском, японском, итальянском и голландском языках, предусмотрена многоязычная поддержка.`)
};

const es_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ofrece soporte multilingüe para contenido con una combinación de inglés, español, francés, alemán, hindi, ruso, portugués, japonés, italiano y holandés.`)
};

const zh_cn2_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容支持多种语言，包括英语、西班牙语、法语、德语、印地语、俄语、葡萄牙语、日语、意大利语和荷兰语。`)
};

const ja_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英語、スペイン語、フランス語、ドイツ語、ヒンディー語、ロシア語、ポルトガル語、日本語、イタリア語、オランダ語が混在したコンテンツに対して多言語サポートが提供されます。`)
};

const hi_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंग्रेजी, स्पेनिश, फ्रेंच, जर्मन, हिंदी, रूसी, पुर्तगाली, जापानी, इतालवी और डच भाषाओं के मिश्रण वाली सामग्री के लिए बहुभाषी समर्थन उपलब्ध कराया जाता है।`)
};

const pt_pt2_multi_language_support_info = /** @type {(inputs: Multi_Language_Support_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conteúdo oferece suporte a vários idiomas, incluindo inglês, espanhol, francês, alemão, hindi, russo, português, japonês, italiano e holandês.`)
};

/**
* | output |
* | --- |
* | "Multi-Language support is offered for content with a mix of English, Spanish, French, German, Hindi, Russian, Portuguese, Japanese, Italian, and Dutch." |
*
* @param {Multi_Language_Support_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multi_language_support_info = /** @type {((inputs?: Multi_Language_Support_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multi_Language_Support_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_multi_language_support_info(inputs)
	if (locale === "de") return de_multi_language_support_info(inputs)
	if (locale === "it") return it_multi_language_support_info(inputs)
	if (locale === "ru") return ru_multi_language_support_info(inputs)
	if (locale === "es") return es_multi_language_support_info(inputs)
	if (locale === "zh-CN") return zh_cn2_multi_language_support_info(inputs)
	if (locale === "ja") return ja_multi_language_support_info(inputs)
	if (locale === "hi") return hi_multi_language_support_info(inputs)
	if (locale === "pt-PT") return pt_pt2_multi_language_support_info(inputs)
	return en_multi_language_support_info(inputs)
});